import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  branch: 0,
};

export const PoBranchSlice = createSlice({
  name: "poBranch",
  initialState,
  reducers: {
    setBranch: (state, action) => {
      state.branch = action.payload;
    },
  },
});

export const { setBranch } = PoBranchSlice.actions;

export default PoBranchSlice.reducer;
